import { Component, OnInit, HostListener} from '@angular/core';
import { UnboxedSample } from '../agptesting-newview/model/unboxing-sample';
import { LabMDM } from '../masterdata/models/lab';
import { ErrorHandler } from '../utils/error-handler';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';
import { MessagesService } from '../messages/messages.service';
import { ConfirmationService } from 'primeng/api';
import { BatchHistory, Covid19Batch, WellType } from '../agptesting-newview/model/covid19Batch';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { Comment } from '../agptesting-newview/model/comment'
import { saveAs as saveByFileSaver } from "file-saver";
import { Printer } from '../masterdata/models/printer';
import { PrintRequest } from '../utils/PrintRequest';
import { Template } from '../masterdata/models/template';
import { Container } from '../models/container';
import { CovidSamples } from '../agptesting-newview/model/covid-sample';
import { Machine } from '../masterdata/models/machine';
import { ZiathRequest } from '../models/ziathRequest';
import { ProcessStepStage } from '../models/process-step-stages';
import { Step } from '../models/step';
import { ProcessStep } from '../models/process-step';

@Component({
  selector: 'app-ng-reception',
  templateUrl: './ng-reception.component.html',
  styleUrls: ['./ng-reception.component.css']
})
export class NGReceptionComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  productList: any[] = [];
  labelPrinterList: any = [];
  customerList: any[] = [];
  swabTypeList: any = [];
  labelCopies: number[];
  batchSize: number[];
  selectedLabId: string;
  batches: Covid19Batch[] = [];
  selectedBatch: Covid19Batch;
  selectedBatchStepsMap: Map<string, Step> = new Map();
  rowColumns: number[];
  unboxingSampleList: UnboxedSample[] = [];
  unboxingNCDummyList: UnboxedSample[] = [];

  isCustomer: boolean = false;
  scannedCustomerBarcode: string;
  scannedEurofinsBarcode: string;
  scannedDocumentBarcode: string;
  mapOfDocumentBarcodes = new Map();
  mapOfCustomerBarcodes = new Map();
  mapOfEurofinsBarcodes = new Map();
  mapOfSenders = new Map();
  backupUnboxMap = new Map();
  mapOfProducts= new Map();
  mapOfWorkflow=new Map();
  customerBarcodeAllowed = false;
  documentBarcodeAllowed = false;
  boxIdScanAllowed = false;
  dirty = false;

  barcodeList: any[] = [];
  scannedBarcodes: string[] = [];
  scannedEurofinsBarcodes: string[] = [];
  selectedSamples: UnboxedSample[] = [];

  redoUnboxedSamples: UnboxedSample[] = [];
  redoSampleList: string[] =[];
  deleteSampleFromUnboxedList: string[] =[];
  redoSampleSenders: string[] =[];
  lastScanMessage: string;
  scannedBarcodeToShow: string;
  colorToShowLastScanMessage: boolean;
  sampleCount: number;

  scannnedBoxId: string;
  loading = false;

  mapOfEurofinsinsBarcodes = new Map();

  showScanDialog = false;
  saveScanErrorHeader = '';
  saveScanErrorBody = '';
  focusFunctionToCall:any;
  showSaveScanErrorPopUp = false;

  dummyNCSampleCount: number;

  newComment: Comment;

  selectedLab: LabMDM;
  isSwabDisabled =true;

  unboxedSender: string;

  isCreate : boolean = true;

  blocked:boolean = false;
  fileSenderName:string
  channelsearched:any
  cutOffValue:any;
  filterOptions: any[];
  selectedStates: string[] = [];
  fromDate: Date;
  toDate: Date;
  startScanClicked : boolean = false;
  problemOptions = [
    { value: 'sampleOk', label: 'Sample OK' },
    { value: 'leaked', label: 'Leaked' },
    { value: 'possibleContamination', label: 'Possible contamination' },
    { value: 'nonConformSwapType', label: 'Non-Conform swap type' },
    { value: 'additionalContentInTube', label: 'Additional content in tube' },
    { value: 'twoSwabsPerTube', label: 'Two swabs per tube' },
    { value: 'tubeBarcodeMissing', label: 'Tube barcode missing' },
    { value: 'manuallyWrittenBarcode', label: 'Manually written barcode' },
    { value: 'duplicateBarcode', label: 'Duplicate barcode' },
    { value: 'tfrTubeBarcodeMismatch', label: 'TFR-Tube barcode mismatch' },
    { value: 'missingTFR', label: 'Missing TFR' },
    { value: 'wrongTube', label: 'Wrong tube' },
    { value: 'missingBoxId', label: 'Missing Box ID'},
    { value: 'invalidBoxId', label: 'Invalid Box ID'},
    { value: 'missingExternalBarcode', label: 'Missing External Barcode'},
    { value: 'invalidExternalBarcode', label: 'Invalid External Barcode'},
    { value: 'wrongOrDuplicatePackaging', label: 'Wrong or duplicate packaging' },
    { value: 'barcodeUnavailableInBMS', label: 'Barcode Not Available In BMS' },
    { value: 'other', label: 'Other' }
  ];
  canAnalyze: boolean;
  problem: string;
  comment: string;
  sampleSaveDisable = true;

  maxDate: Date;
  nonConformVisible = false;
  selectedSender: SenderDTO;

  mapOfProblems = new Map();
  redoSampleMap  = new Map<string,number>();
  redoSampleBarcodesMap = new Map();

  printerList: Printer[] = [];
  selectedPrinter:Printer;
  templateList: Template[] = [];
  selectedTemplate: Template;
  searchFilterList:any[];
  selectedSearchFilter:any;
  valueToSearch : string;
  fieldBatchID: string = "BatchId";
  workflowName: string;
  mapOfProductTagSystem = new Map();
  currentSavedProduct: string;
  scanPlatePopup = false;
  plateViewMode = "";
  showPlateView = true;
  containers : Container[]=[];
  machineList: Machine[];
  ziathHost:string ="";
  ziathName:string ="";
  ziathRequest : ZiathRequest;
  constructor(private _messagesService: MessagesService, private apgTestingService: APGTestingService,
    private confirmationService: ConfirmationService, private masterDataService: MasterDataService) { }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    if (this.dirty) {
      event.returnValue = false;
    }
  }

  canDeactivate() {
    if (this.dirty) {
      return confirm("Scanned samples not yet saved. Do you wish to proceed?");
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.filterOptions = [
      { label: 'Create Batch', value: "CREATE_BATCH" },
      { label: 'Upload Batch', value: "BATCH_UPLOADED" },
      { label: 'Receive Batch', value: "BATCH_RECEIVED" }
    ];

    this.searchFilterList = [
      {label:'Batch Id',value:'BatchId'},
      {label:'Sample Id',value:'SampleId'},
      {label:'External Id',value:'ExternalId'},
      {label:'Library Id',value:'LibraryId'}
    ];
    this.selectedSearchFilter = "BatchId"

    this.maxDate = new Date();
    this.selectedLab = JSON.parse(localStorage.getItem('lab')).lab;
    this.selectedLabId = this.selectedLab._id;
    this.findLabDetails();
    this.puid = localStorage.getItem('PUID');
    this.newComment = new Comment();
    this.selectedBatch = new Covid19Batch();
    this.populateSendersInMap();
    this.getMachineDataforZiath();
    //this.getTemplateOptionsList();
    this.populateProductsInMap();
    this.swabTypeList = [
      { value: 'Dry', label: 'Dry' },
      { value: 'Wet', label: 'Wet' },
      { value: 'Saliva', label: 'Saliva' },
      { value: 'Test', label: 'Test' },
      { value: 'Non standard', label: 'Non standard' },
      { value: 'Mixed', label: 'Mixed' }
    ];

    this.productList =[]

    this.rowColumns = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 3, 35, 36, 37, 38, 39, 40,
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 3, 35, 36, 37, 38, 39, 40,
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

    this.sampleCount = 0;
    this.dummyNCSampleCount = 0;

    this.selectedBatch.wellType = WellType.WELL96;
    this.selectedBatch.count = this.findMaxBatchSize();
    this.selectedBatch.labelCopies = 1;
    this.filterBatchStatus();
    this.selectedBatch.deliveryReceivedDateTime = new Date();
    this.selectedBatch.redoCount = 0;
    this.selectedBatch.processBatchCount=0;
    this.disableBatchReceieve();

    let element = document.getElementById("userID");
    element.focus();

    this.mapOfProblems.set('sampleOk', 'Sample OK');
    this.mapOfProblems.set('missingBoxId', 'Box ID Mandatory');
    this.mapOfProblems.set('invalidBoxId', 'Invalid Box ID');
    this.mapOfProblems.set('missingTFR', 'Document Barcode Is Mandatory');
    this.mapOfProblems.set('tfrTubeBarcodeMismatch', 'Invalid Document Barcode');
    this.mapOfProblems.set('missingExternalBarcode', 'External Barcode Is Mandatory');
    this.mapOfProblems.set('invalidExternalBarcode', 'Invalid External Barcode');
    this.plateViewMode = "MA_NGS_PLATE_VIEW_MODE";
  }

  getprinterOptionsList(): any {
    this.masterDataService.getFilteredPrintersForLabAndEntity(true, this.selectedLabId, 'Plate').subscribe({
      next : (results) => {
        if (!results || results.data.length == 0) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'No Printers Found', detail: 'There are no Printers or Plate Printers defined for this lab.' });
          return;
        }
        this.printerList = results.data.sort((data1: Printer, data2: Printer) => {
          return data1.name.localeCompare(data2.name);
        });

        let selectedPrinter = this.printerList.filter(printer=>printer
             && ((printer.template && printer.template.entity && printer.template.entity == "Plate")&&(printer.defaultPrinter)));

        this.selectedPrinter = selectedPrinter[0];

        if(this.selectedPrinter && this.templateList){
          this.onSelectPrinter();
        }

      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);

      }
    });
  }

  getTemplateOptionsList(): any {
    let lab: LabMDM = new LabMDM();
    lab._id = this.selectedLabId;
    this.masterDataService.getActiveTemplatesForLab(lab,true).subscribe({
      next : (results) => {
        if (!results) {
          return;
        }
         this.templateList = results.data;
         this.getprinterOptionsList();
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }


  showBatchInfo(event: any) {
    this.selectedSamples = [];
    if (this.dirty) {
      this.confirmationService.confirm({
        message: 'Scanned samples not yet saved. Do you wish to proceed?',
        header: 'Discard Changes?',
        accept: () => {
          this.showBatchInfoAction(this.selectedLabId, event);
        },
        reject: () => {}
      });
    } else {
      this.showBatchInfoAction(this.selectedLabId, event);
    }

  }

  showBatchInfoAction(labId, event) {
    this.blocked=true;
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId,this.fieldBatchID, event.data.batchID).subscribe({
      next : (results) => {
        this.selectedBatch = results.data;
        this.currentSavedProduct = this.selectedBatch.product;
        this.isCreate = false;
        this.newComment = this.getPreviewComment(this.selectedBatch);
        this.dummyNCSampleCount = this.getNCDummySampleCount(this.selectedBatch);
        if (this.selectedBatch.deliveryReceivedDateTime) {
          this.selectedBatch.deliveryReceivedDateTime = new Date(this.selectedBatch.deliveryReceivedDateTime);
        }
        this.getSelectedSender();
        this.unboxingSampleList = [];
        this.redoSampleList = [];
        this.redoUnboxedSamples = [];
        this.deleteSampleFromUnboxedList = [];
        this.selectedSamples = [];
        this.initializeMapsForShowingBatch();
        this.prepareProcessStepsMap();
        this.blocked=false;
      },
      error: (error: any) => {
        this.errorHandlerCommon(error);
      }
    });
    if(this.selectedBatch.batchID){
      this.isCreate= false;
    }else{
      this.isCreate= true;
    }
  }

  createMapOutOfUnboxingSamples(unboxSamples: UnboxedSample[]) {
    this.mapOfDocumentBarcodes = new Map();
    this.mapOfCustomerBarcodes = new Map();
    this.mapOfEurofinsBarcodes = new Map();
    unboxSamples.forEach(sample => {
      if (sample.documentBarcode != null && sample.documentBarcode != undefined && sample.documentBarcode.trim() != '') {
        this.mapOfDocumentBarcodes.set(sample.documentBarcode, '');
      }
      if (sample.customersBarcode != null && sample.customersBarcode != undefined && sample.customersBarcode.trim() != '') {
        this.mapOfCustomerBarcodes.set(sample.customersBarcode, '');
      }
      if (sample.eurofinsBarcode != null && sample.eurofinsBarcode != undefined && sample.eurofinsBarcode.trim() != '') {
        this.mapOfEurofinsBarcodes.set(sample.eurofinsBarcode, '');
      }
    });
  }

  isPUIDPresent() {
    if (this.puid) {
      return true;
    }
    return false;
  }

  clearAllFieldsForNewBatch() {
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to continue' });
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: 'Scanned samples not yet saved. Do you wish to proceed?',
        header: 'Discard Changes?',
        accept: () => {
          this.clearAllFieldsForNewBatchAction();
        },
        reject: () => { }
      });
    } else {
      this.clearAllFieldsForNewBatchAction();
    }
  }

  clearAllFieldsForNewBatchAction() {
    this.sampleCount = 0;
    this.dummyNCSampleCount = 0;
    this.selectedSamples = [];
    this.dirty = false;
    this.selectedBatch = new Covid19Batch();
    this.setBatchSender();
    this.selectedBatch.labelCopies = 1;
    this.selectedBatch.count = this.findMaxBatchSize();
    this.selectedBatch.product = '';
    this.selectedBatch.requiredRead=0;
    if(this.customerList.length==1){
    this.selectedBatch.swabType = this.selectedSender.swabType;
    }
    this.selectedBatch.comments = [];
    this.newComment = new Comment();
    this.selectedBatch.wellType = WellType.WELL96;
    this.lastScanMessage = '';
    this.scannedBarcodeToShow = '';
    this.intializationOfUnboxing();
    this.selectedBatch.deliveryReceivedDateTime = new Date();
    let element = document.getElementById("batchID");
    element.focus();
    this.isCreate = true;
    this.disableBatchReceieve();
  }


  saveBatch(saveButton: string) {
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to change status' });
      return;
    }
    if(!this.selectedBatch.sender) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'No sender selected', detail: 'Please select a sender before saving batch' });
      return;
    }
    if(!this.selectedBatch.product) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'No Product selected', detail: 'Please select a product before saving batch' });
      return;
    }
    if(this.selectedLab && this.selectedLab.batchIDRegex && !this.selectedBatch.batchID.match(this.selectedLab.batchIDRegex.trim())){
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Pattern for BatchID', detail: 'BatchID does not match with the configured Pattern in MDM' });
      return;
    }
    if (!this.regexMatcher("^(?!_)[a-zA-Z0-9_]*$", this.selectedBatch.batchID)) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary:'Invalid BatchID!',
        detail:'Batch '+this.selectedBatch.batchID+' cannot be created. Batch ID must contain only 0-9,a-z,A-Z or _'
      });
      return;
    }
    if (!this.regexMatcher("^(?!-)[a-zA-Z0-9-]*$", this.selectedBatch.coProjectId)) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary:'Invalid CO Project ID!',
        detail:'CO Project ID must contain only 0-9,a-z,A-Z or -'
      });
      return;
    }
    if(!this.checkValidationForChangingProduct()){
      return;
    }
    if (this.dirty) {
      this.confirmationService.confirm({
        message: 'Scanned samples not yet saved. Do you wish to proceed?',
        header: 'Create Batch?',
        key:'confirm-overwrite-sample',
        accept: () => {
          this.savebatchConfirm(saveButton);
        },
        reject: () => { }
      });
    } else {
      this.savebatchConfirm(saveButton);
    }

  }

  checkValidationForChangingProduct(){
    this.selectedBatch.workflowGroup = this.mapOfWorkflow.get(this.selectedBatch.product);
    let tagSystem = this.mapOfProductTagSystem.get(this.selectedBatch.product);
    this.selectedBatch.tagSystemName = tagSystem.tagSystemName;
    if(!this.isCreate) {
      let currentSavedWorkFlow = this.mapOfWorkflow.get(this.currentSavedProduct);
      let currentSavedTagSystem = this.mapOfProductTagSystem.get(this.currentSavedProduct);
      if((this.selectedBatch.workflowGroup !== currentSavedWorkFlow) && this.selectedBatch.controlsAddedPUID && this.selectedBatch.controlsAddedDateTime) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Product with different workflow', detail: "Can't change product with different workflow" });
        return false;
      }

      if((this.selectedBatch.tagSystemName !== currentSavedTagSystem.tagSystemName) && (this.selectedBatch.plannedTagPlate || this.selectedBatch.tagPlateId)) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Product with different tag system', detail: "Can't change product with different tag system" });
        return false;
      }
    }
    return true;
  }

  savebatchConfirm(saveButton: string) {
    let shortName = this.selectedSender.senderShortName ? ' (' + this.selectedSender.senderShortName + ') ' : '';
    let currentMessage;
    if(this.isCreate){
      currentMessage = 'Batch ' + this.selectedBatch.batchID + ' Will be created with sender ' + this.selectedBatch.sender + shortName + '. Are you sure you want to continue?';
    } else{
      currentMessage = 'Batch ' + this.selectedBatch.batchID + ' Will be updated with sender ' + this.selectedBatch.sender + shortName + '. Are you sure you want to continue?';
    }
    this.confirmationService.confirm({
      message: currentMessage,
      header: 'Confirm Changes?',
      key:'confirm-batchID',
      accept: () => {
        this.saveBatchAction(saveButton);
      },
      reject: () => { }
    });
  }

  saveBatchAction(saveButton) {
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.labName = this.selectedLab.name;
    this.selectedBatch.batchID = this.selectedBatch.batchID.trim();
    this.getRequiredRead();
    if(saveButton){
      this.selectedBatch.statusOfTheBatch = saveButton;
      this.selectedBatch.previousStatusOfTheBatch = saveButton;
    }
    this.selectedBatch.receptionDateTime = new Date();
    this.selectedBatch.puidUnboxing = this.puid;
    this.selectedBatch.mergeGroup =  this.mapOfSenders.get(this.selectedBatch.sender).mergeGroup?this.mapOfSenders.get(this.selectedBatch.sender).mergeGroup:"";
    this.selectedBatch.rnaPlateID = this.selectedBatch.batchID;
    this.selectedBatch.pcrPlateID = this.isEvaluatePCRPlateID(this.selectedBatch.batchID);
    let history: BatchHistory = new BatchHistory();
    history.currentBatch = history.originalBatch = this.selectedBatch.batchID;
    this.selectedBatch.history = [];
    this.selectedBatch.history.push(history);

    this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe({
      next : (result) => {
        this.selectedBatch = result.data;
        this.currentSavedProduct = this.selectedBatch.product;
        if (this.selectedBatch.deliveryReceivedDateTime) {
          this.selectedBatch.deliveryReceivedDateTime = new Date(this.selectedBatch.deliveryReceivedDateTime);
        }
        if(!this.isCreate){
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated.',
          });
        } else {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Saved!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been saved.',
          });
        }
        this.selectedSamples = [];
        this.initializeMapsForShowingBatch();
        this.isCreate = false;
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    });
  }

  filterBatchStatus() {
    this.apgTestingService.filterBatches("BATCH_UPLOADED", this.selectedLabId, 'OrderReception').subscribe({
      next : (results) => {
        this.batches = results.data;
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })

  }


  verifyBoxId() {
    if (!this.scannnedBoxId || this.scannnedBoxId.trim() == '') {
      if(this.selectedSender.boxBarcode == 'Mandatory Scan') {
        this.saveScanErrorHeader = 'Mandatory Scan';
        this.saveScanErrorBody = 'Box ID is Mandatory';
        this.focusFunctionToCall = this.boxIdFocus;
        this.showScanDialog = true;
        return;
      }
      this.decideFocus();
    } else {
      if(!this.regexMatcher(this.selectedSender.boxBarcodeFormat, this.scannnedBoxId)) {
        this.saveScanErrorHeader = 'Incorrect Format';
        this.saveScanErrorBody = 'Box ID ' + this.scannnedBoxId + ' does not match specified format: ' + this.selectedSender.boxBarcodeFormat;
        this.focusFunctionToCall = this.boxIdFocus;
        this.scannedBarcodeToShow = this.scannnedBoxId;
        this.scannnedBoxId = '';
        this.showScanDialog = true;
        return;
      } else {
        this.colorToShowLastScanMessage = true;
        this.scannedBarcodeToShow = this.scannnedBoxId;
        this.lastScanMessage = 'Box ID ' + this.scannnedBoxId + ' OK';
        this.decideFocus();
      }
    }
  }

  verifyNoDuplicateInDocumentBarcode() {
    if (!this.scannedDocumentBarcode || this.scannedDocumentBarcode.trim() == '') {
      if(this.selectedSender.trfBarcode == 'Mandatory Scan') {
        this.saveScanErrorHeader = 'Mandatory Scan';
        this.saveScanErrorBody = 'Document barcode is Mandatory';
        this.focusFunctionToCall = this.decideFocus;
        this.showScanDialog = true;
        return;
      }
      this.decideFocusAfterDocumentBarcodeScan();
    } else {
      if (this.unboxingSampleList != null && this.unboxingSampleList != undefined) {
        if (this.isUnboxingSampleLengthGreaterThanCount() && this.unBoxingInBatches()) {
          this.saveScanErrorHeader = 'Batch Limit Reached';
          this.saveScanErrorBody = this.selectedBatch.count + ' sample(s) have already been scanned. Cannot exceed batch limit!';
          this.focusFunctionToCall = this.decideFocus;
          this.scannedDocumentBarcode = '';
          this.showScanDialog = true;
          return;
        }
      }
      if(!this.regexMatcher(this.selectedSender.trfFormat, this.scannedDocumentBarcode)) {
        this.saveScanErrorHeader = 'Incorrect Format';
        this.saveScanErrorBody = 'Document barcode ' + this.scannedDocumentBarcode + ' does not match specified format: ' + this.selectedSender.trfFormat;
        this.scannedBarcodeToShow = this.scannedDocumentBarcode;
        this.focusFunctionToCall = this.firstBoxFocus;
        this.scannedEurofinsBarcode = '';
        this.showScanDialog = true;
        return;
      }
      if (this.mapOfDocumentBarcodes.has(this.scannedDocumentBarcode)) {
        this.saveScanErrorHeader = 'Duplicate Scan';
        this.saveScanErrorBody = this.scannedDocumentBarcode + ' already scanned!';
        this.focusFunctionToCall = this.firstBoxFocus;
        this.scannedBarcodeToShow = this.scannedDocumentBarcode;
        this.scannedDocumentBarcode = '';
        this.showScanDialog = true;
      } else {
        this.colorToShowLastScanMessage = true;
        this.scannedBarcodeToShow = this.scannedDocumentBarcode;
        this.lastScanMessage = this.scannedDocumentBarcode + ' OK';
        this.decideFocusAfterDocumentBarcodeScan();
      }
    }
  }

  verifyNoDuplicateInCustomerBarcode() {
    if (!this.scannedCustomerBarcode || this.scannedCustomerBarcode.trim() == '') {
      if(this.selectedSender.externalSampleBarcode == 'Mandatory Scan'){
        this.saveScanErrorHeader = 'Mandatory Scan';
        this.saveScanErrorBody = 'External barcode is Mandatory';
        this.focusFunctionToCall = this.secondBoxFocus;
        this.showScanDialog = true;
        return;
      }
      this.thirdBoxFocus();
    } else {
      if (this.unboxingSampleList != null && this.unboxingSampleList != undefined) {
        if (this.isUnboxingSampleLengthGreaterThanCount() && this.unBoxingInBatches()) {
          this.saveScanErrorHeader = 'Batch Limit Reached';
          this.saveScanErrorBody = this.selectedBatch.count + ' sample(s) have already been scanned. Cannot exceed batch limit!';
          this.focusFunctionToCall = this.decideFocus;
          this.scannedCustomerBarcode = '';
          this.showScanDialog = true;
          return;
        }
      }
      if (this.mapOfCustomerBarcodes.has(this.scannedCustomerBarcode)) {
        this.saveScanErrorHeader = 'Duplicate Scan';
        this.saveScanErrorBody = this.scannedCustomerBarcode + ' already scanned!';
        this.focusFunctionToCall = this.secondBoxFocus;
        this.scannedBarcodeToShow = this.scannedCustomerBarcode;
        this.scannedCustomerBarcode = '';
        this.showScanDialog = true;
      } else {
        this.colorToShowLastScanMessage = true;
        this.scannedBarcodeToShow = this.scannedCustomerBarcode;
        this.lastScanMessage = this.scannedCustomerBarcode + ' OK';
        this.thirdBoxFocus();
      }
    }
  }

  verifyNoDuplicateInEurofinsBarcode(){
    this.getSenderForEurofinsBarcode(this.scannedEurofinsBarcode);
  }
  processEurofinsBarcode() {
    if (this.scannedEurofinsBarcode == null || this.scannedEurofinsBarcode == undefined || this.scannedEurofinsBarcode.trim() == '') {
      this.saveScanErrorHeader = 'Empty Scan';
      this.saveScanErrorBody = 'Scan Eurofins barcode To Proceed. Or press Scan Complete if all samples entered.';
      this.focusFunctionToCall = this.thirdBoxFocus;
      this.showScanDialog = true;
      return;
    } else {
      if(this.loading) {
        this.decideFocus();
        return;
      }
      if (this.unboxingSampleList == null || this.unboxingSampleList == undefined) {
        this.unboxingSampleList = [];
      }
      if (this.scannedEurofinsBarcode != 'NC-DUMMY' && this.isUnboxingSampleLengthGreaterThanCount() && this.unBoxingInBatches()) {
        this.saveScanErrorHeader = 'Batch Limit Reached';
        this.saveScanErrorBody = this.selectedBatch.count + ' sample(s) have already been scanned. Cannot exceed batch limit!';
        this.focusFunctionToCall = this.decideFocus;
        this.scannedEurofinsBarcode = '';
        this.showScanDialog = true;
        return;
      }

      if(!this.regexMatcher(this.selectedSender.barcodeFormat, this.scannedEurofinsBarcode) && this.scannedEurofinsBarcode != 'NC-DUMMY') {
        this.saveScanErrorHeader = 'Incorrect Format';
        this.saveScanErrorBody = 'Eurofins barcode ' + this.scannedEurofinsBarcode + ' does not match specified format: ' + this.selectedSender.barcodeFormat;
        this.scannedEurofinsBarcode = '';
        this.focusFunctionToCall = this.thirdBoxFocus;
        this.showScanDialog = true;
        return;
      }
      if (this.scannedCustomerBarcode == this.scannedEurofinsBarcode) {
        this.saveScanErrorHeader = 'Incorrect Entry';
        this.saveScanErrorBody = 'External barcode should not be same as Eurofins barcode. Please correct.';
        this.scannedBarcodeToShow = this.scannedEurofinsBarcode;
        this.scannedEurofinsBarcode = '';
        this.scannedCustomerBarcode = '';
        this.focusFunctionToCall = this.secondBoxFocus;
        this.showScanDialog = true;
        return;
      }
      if(!this.validateCheckForIdentity()){
        this.focusFunctionToCall = this.decideFocus;
        this.showScanDialog = true;
        return;
      }
      if (this.mapOfEurofinsBarcodes.has(this.scannedEurofinsBarcode) && this.scannedEurofinsBarcode != 'NC-DUMMY') {
        this.saveScanErrorHeader = 'Duplicate Scan';
        this.saveScanErrorBody = this.scannedEurofinsBarcode + ' has already been scanned.';
        this.focusFunctionToCall = this.thirdBoxFocus;
        this.scannedEurofinsBarcode = '';
        this.showScanDialog = true;
      } else {
        var unboxedSample = this.getSampleToInsert();
        if(this.scannedEurofinsBarcode != 'NC-DUMMY') {
          if(unboxedSample.problem == 'missingBoxId') {
            this.saveScanErrorHeader = 'Mandatory Scan';
            this.saveScanErrorBody = 'Box Id is Mandatory';
            this.focusFunctionToCall = this.boxIdFocus;
            this.showScanDialog = true;
            return;
          } else if(unboxedSample.problem == 'invalidBoxId') {
            this.saveScanErrorHeader = 'Incorrect Format';
            this.saveScanErrorBody = 'Box ID ' + this.scannnedBoxId + ' does not match specified format: ' + this.selectedSender.boxBarcodeFormat;
            this.focusFunctionToCall = this.boxIdFocus;
            this.showScanDialog = true;
            return;
          } else if(unboxedSample.problem == 'missingTFR') {
            this.saveScanErrorHeader = 'Mandatory Scan';
            this.saveScanErrorBody = 'Document barcode is Mandatory';
            this.focusFunctionToCall = this.firstBoxFocus;
            this.showScanDialog = true;
            return;
          } else if(unboxedSample.problem == 'tfrTubeBarcodeMismatch') {
            this.saveScanErrorHeader = 'Incorrect Format';
            this.saveScanErrorBody = 'Document barcode ' + this.scannedDocumentBarcode + ' does not match specified format: ' + this.selectedSender.trfFormat;
            this.focusFunctionToCall = this.firstBoxFocus;
            this.showScanDialog = true;
            return;
          } else if(unboxedSample.problem == 'missingExternalBarcode') {
            this.saveScanErrorHeader = 'Mandatory Scan';
            this.saveScanErrorBody = 'External barcode is Mandatory';
            this.focusFunctionToCall = this.secondBoxFocus;
            this.showScanDialog = true;
            return;
          } else if(unboxedSample.problem == 'invalidExternalBarcode') {
            this.saveScanErrorHeader = 'Incorrect Format';
            this.saveScanErrorBody = 'External barcode ' + this.scannedCustomerBarcode + ' does not match specified format: ' + this.selectedSender.externalSampleFormat;
            this.focusFunctionToCall = this.secondBoxFocus;
            this.showScanDialog = true;
            return;
          }
        }

        this.dirty = true;
        this.scannedBarcodeToShow = this.scannedEurofinsBarcode;
        if(unboxedSample.canAnalyze == true && unboxedSample.problem == 'sampleOk') {
          if(this.scannedDocumentBarcode && this.scannedDocumentBarcode.trim() != '') {
            this.mapOfDocumentBarcodes.set(this.scannedDocumentBarcode, '')
          }
          if(this.scannedCustomerBarcode && this.scannedCustomerBarcode.trim() != '') {
            this.mapOfCustomerBarcodes.set(this.scannedCustomerBarcode, '')
          }
            this.mapOfEurofinsBarcodes.set(this.scannedEurofinsBarcode, '');
            this.colorToShowLastScanMessage = true;
            this.lastScanMessage = this.scannedEurofinsBarcode + ' OK';
        }
        this.validateEurofinsBarcode();
        this.dummyNCSampleCount = this.getNCDummyCount(this.unboxingSampleList);
        this.sampleCount = this.getSampleCount(this.unboxingSampleList);
      }
    }
  }
  validateCheckForIdentity() {
    if(this.selectedSender.checkForIdentity == 'TRF = Sample' && this.scannedDocumentBarcode && this.scannedEurofinsBarcode){
      if(this.scannedDocumentBarcode != this.scannedEurofinsBarcode){
        this.saveScanErrorHeader = 'Incorrect Entry';
        this.saveScanErrorBody = 'Document Barcode Should be same as Eurofins Barcode';
        this.scannedDocumentBarcode = '';
        this.scannedEurofinsBarcode = '';
        return false;
      }
    }
    else if(this.selectedSender.checkForIdentity == 'TRF = External' && this.scannedDocumentBarcode && this.scannedCustomerBarcode){
      if(this.scannedDocumentBarcode != this.scannedCustomerBarcode){
        this.saveScanErrorHeader = 'Incorrect Entry';
        this.saveScanErrorBody = 'Document Barcode Should be same as Customer Barcode';
        this.scannedDocumentBarcode = '';
        this.scannedCustomerBarcode = '';
        return false;
      }
    }
    else{
      return true;
    }
    return true;
  }

  getSampleToInsert() {
    let analyzed = true;
    let cause;
    if (!this.scannnedBoxId || this.scannnedBoxId.trim() == '') {
      if (this.selectedSender.boxBarcode == 'Mandatory Scan') {
        analyzed = false;
        cause = 'missingBoxId';
      } else if(this.scannedEurofinsBarcode == 'NC-DUMMY'){
        analyzed = false;
        cause = 'sampleOk';
      }else{
        cause = this.findCauseForNonConform();
      }
    }else if (!this.regexMatcher(this.selectedSender.boxBarcodeFormat, this.scannnedBoxId)) {
      analyzed = false;
      cause = 'invalidBoxId';
    }else if(this.scannedEurofinsBarcode == 'NC-DUMMY'){
      analyzed = false;
      cause = 'sampleOk';
    } else {
      cause = this.findCauseForNonConform();
    }
    return { 'documentBarcode': this.scannedDocumentBarcode, 'customersBarcode': this.scannedCustomerBarcode, 'eurofinsBarcode': this.scannedEurofinsBarcode, 'canAnalyze': analyzed, 'problem': cause, 'comment': '', 'boxId': this.scannnedBoxId, 'unboxedSender': this.unboxedSender,'redoSampleFlag': false}
  }

  getSenderForEurofinsBarcode(scannedEurofinsBarcode: string) {
    // remove old method of APG
  }

  findSenderByContactID(contactId: string) {
    this.unboxedSender = this.selectedSender.senderShortName;
    this.mapOfSenders.forEach((value: string, key: UnboxedSample) => {
      let tempSender: any = value;
      if (tempSender.contactID === contactId) {
        this.unboxedSender = tempSender.senderShortName;
      }
    });
  }

  validateSenderMergeGroup(contactId: string) {
    if (contactId) {
      var extractedSender: SenderDTO;
      this.mapOfSenders.forEach((value: string, key: UnboxedSample) => {
        let tempSender: any = value;
        if (tempSender.contactID === contactId) {
          extractedSender = tempSender;
        }
      });
      if (extractedSender && (extractedSender.mergeGroup !== this.selectedSender.mergeGroup)) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Merge group missmatch',
        detail: 'Sample ' + this.scannedEurofinsBarcode + ' belongs to sender '
        + extractedSender.senderShortName + ' which belongs to merge group ' + extractedSender.mergeGroup });
        return;
      }
    }
  }

  findCauseForNonConform() {
    if ((!this.scannedDocumentBarcode || this.scannedDocumentBarcode.trim() == '') && this.selectedSender.trfBarcode == 'Mandatory Scan') {
        return 'missingTFR'
    } else if((this.scannedDocumentBarcode && this.scannedDocumentBarcode.trim() != '') && !this.regexMatcher(this.selectedSender.trfFormat, this.scannedDocumentBarcode)) {
        return 'tfrTubeBarcodeMismatch';
    } else if ((!this.scannedCustomerBarcode || this.scannedCustomerBarcode.trim() == '') && this.selectedSender.externalSampleBarcode == 'Mandatory Scan') {
        return 'missingExternalBarcode'
    } else {
      return 'sampleOk';
    }
  }

  removeSelectedSamples() {
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    if (this.selectedBatch.batchID == null || this.selectedBatch.batchID == undefined || this.selectedBatch.batchID == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Batch ID Empty', detail: 'Please enter Batch ID to change status' });
      return;
    }
    if (this.selectedSamples == null || this.selectedSamples == undefined || this.selectedSamples.length == 0) {
      return;
    }

    let sampleBarcodesToBeDeleted = [];
    this.selectedSamples.forEach(sample => {
      if (this.backupUnboxMap.has(sample.eurofinsBarcode)) {
        sampleBarcodesToBeDeleted.push(sample.eurofinsBarcode);
      }
    })
    let messageForDeletion = '';

        if(sampleBarcodesToBeDeleted.length != 0){
          messageForDeletion = 'Eurofins barcodes : '  + sampleBarcodesToBeDeleted.join(", ") +' have been SCAN COMPLETED but will be removed.';
        } else {
          messageForDeletion = 'Selected eurofins barcodes will be removed!';
        }

      let messageOnDialog = messageForDeletion + ' Do you wish to proceed?';

      this.confirmationService.confirm({
        message: messageOnDialog,
        header: 'Confirm Delete',
        accept: () => {

          this.unboxingSampleList = this.unboxingSampleList.filter(sample => {
            if (this.selectedSamples.includes(sample) && this.mapOfEurofinsinsBarcodes.has(sample.eurofinsBarcode)) {
              return true;
            } else if (this.selectedSamples.includes(sample) && !this.mapOfEurofinsinsBarcodes.has(sample.eurofinsBarcode)) {
                 this.redoSampleList = this.redoSampleList.filter(barcode=>barcode!=sample.eurofinsBarcode);
              return false;
            } else if (!this.selectedSamples.includes(sample) && this.mapOfEurofinsinsBarcodes.has(sample.eurofinsBarcode)) {
              return true;
            } else {
              return true;
            }
          });
          this.selectedSamples.forEach(sample => {
              this.mapOfCustomerBarcodes.delete(sample.customersBarcode);
              this.mapOfDocumentBarcodes.delete(sample.documentBarcode);
              this.mapOfEurofinsBarcodes.delete(sample.eurofinsBarcode);
              this.mapOfDocumentBarcodes.delete(sample.documentBarcode);
              this.addToredoRemoveList(sample);
          });
          this.sampleCount = this.getSampleCount(this.unboxingSampleList);
          this.dummyNCSampleCount = this.getNCDummyCount(this.unboxingSampleList);
          this.selectedBatch.unboxedSamples = this.unboxingSampleList;
          this.selectedSamples = [];
        },
        reject: () => {
          this.selectedSamples = [];
        }
      });

  }

  isUnboxingSampleLengthGreaterThanCount() {
    return (this.selectedBatch.count <= this.sampleCount);
  }

  initializeScanningDisplayVariables() {
    this.scannedCustomerBarcode = '';
    this.scannedEurofinsBarcode = '';
    this.scannedDocumentBarcode = '';
    this.scannnedBoxId = '';
    this.lastScanMessage = '';
    this.scannedBarcodeToShow = '';
    this.dirty = false;
  }

  intializationOfUnboxing() {
    this.unboxingSampleList = [];
    this.mapOfCustomerBarcodes = new Map();
    this.mapOfDocumentBarcodes = new Map();
    this.mapOfEurofinsBarcodes = new Map();
    this.backupUnboxMap = new Map();
    this.initializeScanningDisplayVariables();
  }

  prepareBatchForScan(scanCompleteButton: string) {
    this.selectedBatch.lab = this.selectedLabId;
    this.selectedBatch.statusOfTheBatch = scanCompleteButton;
    this.selectedBatch.previousStatusOfTheBatch = scanCompleteButton;
    this.selectedBatch.scanCompleteDateTime = new Date();
    this.selectedBatch.redoUnboxedSamples =[];
    this.selectedBatch.unboxedSamples =[];
    this.selectedBatch.unboxedSamplesForReceived =[];
    this.unboxingSampleList.forEach(unBoxedSample => {
      if(unBoxedSample.redoSampleFlag){
        this.selectedBatch.redoUnboxedSamples.push(unBoxedSample);
      }else {
        if(!this.backupUnboxMap.has(unBoxedSample.eurofinsBarcode) && unBoxedSample.eurofinsBarcode != 'NC-DUMMY'){
          this.selectedBatch.unboxedSamplesForReceived.push(unBoxedSample);
        }
         this.selectedBatch.unboxedSamples.push(unBoxedSample);
        }
    });
    this.selectedBatch.redoSampleList = this.redoSampleList;
    this.selectedBatch.deleteSampleFromUnboxedList = this.deleteSampleFromUnboxedList;
  }

  copyToUnbox() {
    this.unboxingNCDummyList = [];
    this.unboxingSampleList = [];
    this.redoUnboxedSamples =[];
    this.redoSampleList = [];
    this.deleteSampleFromUnboxedList =[];
    this.backupUnboxMap = new Map();
    if (this.selectedBatch.unboxedSamples ) {
      this.selectedBatch.unboxedSamples.forEach(val => {
        if (!val.problem || val.problem == '') {
          val.canAnalyze = true;
        }
        this.unboxingSampleList.push(Object.assign({}, val));
        this.backupUnboxMap.set(val.eurofinsBarcode, '');
      });
    }
  }

  shiftFocusToDocumentBarcode() {
    let element = document.getElementById("firstBox");
    element.focus();
  }

  initializeMapsForShowingBatch() {
    this.copyToUnbox();
    if (this.unboxingSampleList.length != 0) {
      this.createMapOutOfUnboxingSamples(this.unboxingSampleList);
      this.initializeScanningDisplayVariables();
    } else {
      this.intializationOfUnboxing();
      this.initializeScanningDisplayVariables();
    }
    this.sampleCount = this.getSampleCount(this.unboxingSampleList);
  }

  decideFocus() {
    if (this.documentBarcodeAllowed) {
      let element = document.getElementById("firstBox");
      element.focus();
    } else if (this.customerBarcodeAllowed) {
      let element = document.getElementById("secondBox");
      element.focus();
    } else {
      let element = document.getElementById("thirdBox");
      element.focus();
    }
  }

  decideBarcodeAllowance() {
    // remove this method old code APG
  }

  getSampleSizeClass() {
    if (this.sampleCount < this.selectedBatch.count) {
      return "lastMessageLabelInRange";
    } else {
      return "lastMessageLabelAtLimit";
    }
  }

  showNonConformPopUp() {
    this.canAnalyze = this.selectedSamples[0].canAnalyze;
    this.problem = this.selectedSamples[0].problem;
    this.comment = this.selectedSamples[0].comment;
    this.nonConformVisible = true;
    if (!this.backupUnboxMap.has(this.selectedSamples[0].eurofinsBarcode)) {
      this.sampleSaveDisable = false;
    }
  }

  hideNonConformPopUp() {
    this.selectedSamples[0].canAnalyze = this.canAnalyze;
    this.selectedSamples[0].problem = this.problem;
    this.selectedSamples[0].comment = this.comment;
    this.sampleCount = this.getSampleCount(this.unboxingSampleList);
    this.nonConformVisible = false;
    this.selectedSamples = [];
    this.sampleSaveDisable = true;
  }

  clearSelection() {
    this.selectedSamples = [];
  }

  saveDisabledIf() {
    return !(this.selectedBatch.statusOfTheBatch
       && ['CREATE_BATCH', 'SCAN_COMPLETE', 'START_CLIPPING', 'COMPLETE_CLIPPING'].includes(this.selectedBatch.statusOfTheBatch));
  }

  createBatchDisabledIf(){

    return (this.unboxingSampleList.length > 0
                || (this.selectedBatch.unboxedSamples && this.selectedBatch.unboxedSamples.length > 0));
  }

  populateSendersInMap() {
    this.masterDataService.getConfigList(this.selectedLabId, "sender", 0, 100, true).subscribe(
      (result)=>{
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {

            let tempSender:any = value;
            let labelValue = tempSender.senderShortName ? tempSender.senderShortName : tempSender.senderName;
            this.mapOfSenders.set(tempSender.senderName, value);
            this.customerList.push({ label: labelValue, value: tempSender.senderName });
          });
          this.setBatchSender();
          this.selectedSender = this.mapOfSenders.get(this.customerList[0].value);
          if(this.customerList.length==1){
          this.selectedBatch.swabType= this.selectedSender.swabType;
          }
          this.customerList.sort((a,b) => a.label.localeCompare(b.label));
          this.setVisibilityForDocumentAndExternalBarcodes();
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  setBatchSender() {
    if(this.customerList.length == 1) {
      this.selectedBatch.sender = this.customerList[0].value;

    } else {
      this.selectedBatch.sender = null;
    }
  }

  setVisibilityForDocumentAndExternalBarcodes() {
    this.boxIdScanAllowed = this.selectedSender.boxBarcode == 'Not Used' ? false : true;
    this.documentBarcodeAllowed = this.selectedSender.trfBarcode == 'Not Used' ? false : true;
    this.customerBarcodeAllowed = this.selectedSender.externalSampleBarcode == 'Not Used' ? false : true;
  }

  getSelectedSender(){
    this.selectedSender = this.mapOfSenders.get(this.selectedBatch.sender);
    if(!this.selectedSender) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Sender Not Found', detail: 'Please configure Sender '+ this.selectedBatch.sender + ' to continue with this batch.' });
      return;
    }
    if(!this.selectedBatch._id){
    this.selectedBatch.swabType = this.selectedSender.swabType;
    this.selectedBatch.rushSample =  this.selectedSender.defaultPriority == "Rush";
    this.getLatestBatchIdBySender(this.selectedLabId, this.selectedSender.senderName);
    }
    this.setVisibilityForDocumentAndExternalBarcodes();
  }

  regexMatcher(regex: string, barcode: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(barcode);
  }

  getSampleCount(sampleList: UnboxedSample[]) {
    let count = 0;
    sampleList.forEach(sample => {
      if(sample.eurofinsBarcode !='NC-DUMMY' && sample.canAnalyze == true) {
        count++;
      }
    })
    return count;
  }

  getNCDummyCount(sampleList: UnboxedSample[]) {
    let count = 0;
    sampleList.forEach(covid19Sample => {
      if(covid19Sample.eurofinsBarcode =='NC-DUMMY' && covid19Sample.canAnalyze != true) {
        count++;
      }
    })
    return count;
  }

  validateEurofinsBarcode(){
    this.loading = true;
    var unboxedSample = this.getSampleToInsert();
     if(this.scannedEurofinsBarcode == 'NC-DUMMY'){
       this.loading = false;
       if(unboxedSample.canAnalyze == false && unboxedSample.problem == 'sampleOk'){
        this.unboxingSampleList.unshift(unboxedSample);
        this.unboxingNCDummyList.push(unboxedSample);
       }
       this.scannedCustomerBarcode = '';
       this.scannedDocumentBarcode = '';
       this.scannedEurofinsBarcode = '';
       this.decideFocus();
       return;
     }else if (this.redoSampleBarcodesMap.has(unboxedSample.eurofinsBarcode)) {
         unboxedSample.redoSampleFlag = true;
         this.redoSampleList.push(unboxedSample.eurofinsBarcode);
         this.unboxingSampleList.unshift(unboxedSample);
         this.sampleCount = this.getSampleCount(this.unboxingSampleList);
         this.scannedCustomerBarcode = '';
         this.scannedDocumentBarcode = '';
         this.scannedEurofinsBarcode = '';
         this.loading = false;
         this.decideFocus();
    }
    if(!unboxedSample.redoSampleFlag){
    this.apgTestingService.validateEurofinsBarcode(this.scannedEurofinsBarcode, this.selectedLabId, this.selectedSender.barcodeValidationRequired).subscribe({
      next : (result) => {
        if (result.data) {
          if(unboxedSample.canAnalyze == true && unboxedSample.problem == 'sampleOk'){
             this.unboxingSampleList.unshift(unboxedSample);
          }
          this.sampleCount = this.getSampleCount(this.unboxingSampleList);
          this.scannedCustomerBarcode = '';
          this.scannedDocumentBarcode = '';
          this.scannedEurofinsBarcode = '';
          this.loading = false;
          this.decideFocus();
        }
      },
      error: (error: any) => {
        this.saveScanErrorHeader = 'Scan Error';
        this.saveScanErrorBody = error.error.bbApiError.message;
        this.focusFunctionToCall = this.thirdBoxFocus;
        this.showScanDialog = true;
        this.mapOfCustomerBarcodes.delete(this.scannedCustomerBarcode);
        this.mapOfDocumentBarcodes.delete(this.scannedDocumentBarcode);
        this.mapOfEurofinsBarcodes.delete(this.scannedEurofinsBarcode);
        this.scannedCustomerBarcode = '';
        this.scannedDocumentBarcode = '';
        this.scannedEurofinsBarcode = '';
        this.sampleCount = this.getSampleCount(this.unboxingSampleList);
        this.loading = false;
      }
    });
  }
  }

  decideFocusAfterDocumentBarcodeScan() {
    if(this.customerBarcodeAllowed) {
      let element = document.getElementById("secondBox");
      element.focus();
    } else {
      let element = document.getElementById("thirdBox");
      element.focus();
    }
  }

  isScanElementDisabled() {
    return (this.selectedBatch && this.selectedBatch.receptionDateTime && this.selectedBatch.puidUnboxing
      && (this.selectedBatch.statusOfTheBatch !=='CREATE_BATCH'));
  }

  disableSwab($event){
    this.isSwabDisabled =  $event.checked == false;
     }

  isRegisteredUnboxedSamples(eurofinsBarcode: string) {
    return this.mapOfEurofinsinsBarcodes.has(eurofinsBarcode)
  }

  isRegisteredUnboxedSamplesStyle(eurofinsBarcode: string) {
    if (this.mapOfEurofinsinsBarcodes.has(eurofinsBarcode)) {
      return {
        'color': '#BEBEBE'
      };
    }
  }



  isSaveBatchDisabledIf(){
    return !(this.selectedBatch.statusOfTheBatch && this.selectedBatch.statusOfTheBatch == 'CREATE_BATCH');
  }

  isEvaluatePCRPlateID(batchId : string){
    if(this.regexMatcher("^([A-z?0-9?]+_[0-9])([A-z]?[0-9]?-?)*$", batchId)){
      var partsOfBatchId = batchId.split(/_(.+)/);
      if(!isNaN(Number(partsOfBatchId[1].charAt(0)))){
        batchId = partsOfBatchId[0]+'_RT'+partsOfBatchId[1];
      }
    }
      return batchId;
  }

  addNCDummyBarcodes() {
    this.scannedEurofinsBarcode = "NC-DUMMY";
    this.verifyNoDuplicateInEurofinsBarcode()
  }

  getNCDummySampleCount(batch : Covid19Batch){
      let count = 0;
      batch.unboxedSamples.forEach(covidSample => {
        if(covidSample.eurofinsBarcode =='NC-DUMMY') {
          count++;
        }
      })
      return count;
  }

  closeScanErrorPopUp() {
    this.showScanDialog = false;
  }

  closeScanSaveErrorPopUp() {
    this.showSaveScanErrorPopUp = false;
  }

  focusDeciderAfterHide() {
    this.focusFunctionToCall();
  }

  firstBoxFocus() {
    let element = document.getElementById("firstBox");
    element.focus();
  }

  secondBoxFocus() {
    let element = document.getElementById("secondBox");
    element.focus();
  }

  thirdBoxFocus() {
    let element = document.getElementById("thirdBox");
    element.focus();
  }

  boxIdFocus() {
    let element = document.getElementById("boxIdBox");
    element.focus();
  }


  getPreviewComment(batch: Covid19Batch) {
    let comment = new Comment();
    if(batch.comment) {
      comment.batchId = batch.batchID;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = batch.comment;
    } else if(batch.comments && batch.comments.length > 0) {
      comment = Object.assign({}, batch.comments[batch.comments.length - 1]);
    } else {
      comment.userComment = '';
    }
    return comment;
  }

  intializeNewComment() {
    this.newComment.puid = this.puid;
    this.newComment.batchId = this.selectedBatch.batchID;
    this.newComment.commentDate = new Date();
  }

  private handleOptimisticLock(batchID: string){
    this._messagesService.addWarningMessage({
      severity: 'warn', summary: 'Parallel updation occurred',
      detail: 'Batch ' + this.selectedBatch.batchID + ' has been modified by other user. Scanned samples have been merged',
    });
    this.blocked=true;
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId,this.fieldBatchID , batchID).subscribe({
      next : (results) => {
       this.selectedBatch = results.data;
       this.addMissedSamplesDuringOptimisticLockError();
       this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe({
          next : (result) => {
            this.selectedBatch = result.data;
            this.copyToUnbox();
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Scan Completed',
              detail: 'Batch ' + this.selectedBatch.batchID + ' has been scanned.',
            });
            this.initializeScanningDisplayVariables();
          },
          error: (error: any) => {
            this.saveScanErrorHeader = "Scan Complete Error";
            this.saveScanErrorBody = error.error.bbApiError.message;
            this.showSaveScanErrorPopUp = true;
          }});
          this.blocked=false;
      },
      error: (error: any) => {
        this.errorHandlerCommon(error);
      }
    });
  }

  private addMissedSamplesDuringOptimisticLockError(){
    let missedSampels = this.unboxingSampleList.filter(sample => !this.backupUnboxMap.has(sample.eurofinsBarcode) && sample.eurofinsBarcode != 'NC-DUMMY');
    missedSampels.forEach(sample => {
      if(!(this.selectedBatch.unboxedSamples.some(s => s.eurofinsBarcode === sample.eurofinsBarcode))){
        this.selectedBatch.unboxedSamples.unshift(sample);
      }
    });
    this.unboxingNCDummyList.forEach(ncDummy => {
      this.selectedBatch.unboxedSamples.unshift(ncDummy);
    });
    this.selectedBatch.unboxedSamplesForReceived = missedSampels;
  }

  setLabelFocus(errorTextArea: HTMLInputElement){
    setTimeout(() => {​​​​​
      errorTextArea.focus();
      }​​​​​, 50);
  }

  findMaxBatchSize(){
   return 94;
}

findLabDetails(){
  this.masterDataService.findLabById(this.selectedLabId).subscribe({
    next : (result) => {
      if (result.data == null || result.data == undefined || result.data.length == 0) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'LabÂ notÂ found!', detail: 'ContactÂ AdministratorÂ toÂ resolveÂ thisÂ issue.' });
        return;
      }
      this.selectedLab = result.data;
      if(this.unBoxingInBatches()){
      this.selectedBatch.count = this.findMaxBatchSize();
      }
    },
    error: (error: any) => {
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    }
  });
}


saveFile(data: any, filename?: string) {
  const blob = new Blob([data], { type: 'application/octet-stream' });
  saveByFileSaver(blob, filename);
}
isRedoSamplesAvailable(){
  return this.redoSampleSenders.length > 0 ;
}

getNoOfRedoSamplesForSender(sender: string){
 return this.redoSampleMap.get(sender);
}
addToredoRemoveList(sample){
  if(sample.redoSampleFlag){
    this.deleteSampleFromUnboxedList.push(sample.eurofinsBarcode);
  }
}
unBoxingInBatches(){
  return this.selectedLab?this.selectedLab.unboxingInBatches:true;
}

checkBatchExistance(batchId : string){
  if(batchId){
    this.blocked=true;
    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId, this.fieldBatchID, batchId).subscribe({
      next : (result) => {
        if (result.data) {
          this._messagesService.addWarningMessage({
            severity: 'warn', summary: 'Batch Exists',
            detail: 'Found an existing batch for: '+batchId+' and will now perform Update.'+
            'To create new batch please click "New Batch" and use a different batch ID'});
              this.isCreate = false;
              this.selectedBatch = result.data;
              this.dummyNCSampleCount = this.getNCDummySampleCount(this.selectedBatch);
              this.getSelectedSender();
              this.unboxingSampleList = [];
              this.selectedSamples = [];
              this.initializeMapsForShowingBatch();
        } else {
          this.isCreate = true;
        }
        this.blocked=false;
      },
      error: (error: any) => {
        this.blocked = false;
        if(error.error.bbApiError.message.includes("Batch not found!")){
          this.isCreate = true;
        }else{
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      }
    });
  }

}

onExcelUpload(event, fileUploader: HTMLInputElement, isCustomer:boolean){
  if (this.selectedBatch.samples && this.selectedBatch.samples.length > 0) {
    this.confirmationService.confirm({
      message: 'The existing sample information will be overwritten if you go forward with uploaded excel. Do you wish to continue?',
      header: 'Confirmation',
      key:'confirm-overwrite-sample',
      accept: () => {
        this.onSubmitConfirm(event.files[0], fileUploader, isCustomer);
      }
    });
  } else {
    this.onSubmitConfirm(event.files[0], fileUploader, isCustomer);
  }
}
getFileUploadStyle() {
  return {
    'margin-top': '1%',
    'font-weight': 'bold',
    'font-size': '14px',
    'padding': '4px 0px 4px 0px',
    'border-radius': '5px',
    'background-color': 'rgb(65, 130, 126)',
    'border': 'none',
    'height':'38px'
  }
}

onSubmitConfirm(fileInput: any, fileUploader: any,isCustomer:boolean){
  let fileNameWithoutExt = fileInput.name.substring(0, fileInput.name.lastIndexOf('.'))
  if(!fileNameWithoutExt.endsWith(this.selectedBatch.batchID)){
    this.confirmationService.confirm({
      message: 'Uploaded file name does not end with the Batch ID. Do you wish to continue?',
      header: 'Confirmation different Batch Name',
      key:'confirm-batchID',
      accept: () => {
        this.onSubmit(fileInput, fileUploader, isCustomer);
      },
      reject: () => {
        fileUploader.clear();
      }
    });
  } else{
    this.onSubmit(fileInput, fileUploader, isCustomer);
  }
}

// on upload of the selected file
onSubmit(fileInput: any, fileUploader: any, isCustomer:boolean) {
  this.blocked = true;
  this.selectedBatch.excelUploadCreatedAt = new Date();
  this.selectedBatch.excelUploadCreatedBy = this.puid;
  const formData = new FormData();
  formData.append('fileName', fileInput.name);
  formData.append('labId', this.selectedLabId);
  formData.append('batchID', this.selectedBatch.batchID);
  formData.append('labName',this.selectedBatch.labName);

  if(this.selectedBatch.externalIdentification === null || this.selectedBatch.externalIdentification === undefined){
    formData.append('externalIdentification', '');
  } else {
    formData.append('externalIdentification', this.selectedBatch.externalIdentification);
  }
  if(this.selectedBatch.regionalCode === null || this.selectedBatch.regionalCode === undefined){
    formData.append('regionalCode', '');
  } else {
    formData.append('regionalCode', this.selectedBatch.regionalCode);
  }
  formData.append('excelUploadCreatedBy', this.selectedBatch.excelUploadCreatedBy);
  var datestr = (new Date(this.selectedBatch.excelUploadCreatedAt)).toUTCString();
  formData.append('excelUploadCreatedAt', datestr);
  formData.append('senderName',this.selectedBatch.sender);
  formData.append('product',this.selectedBatch.product);
  this.workflowName=this.mapOfWorkflow.get(this.selectedBatch.product);

  if(isCustomer){
    if(this.workflowName!='Midplex'){
      formData.append('file', fileInput);
      this.uploadCustomerExcel(formData, fileUploader);
    }else{
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Wrong Product',
        detail: 'Please select Artic Product to continue working'
      });
      fileUploader.clear();
      this.blocked = false;
      return;
    }
  }else{
    if(this.workflowName!='Midplex'){
      //for internal excel upload
      const genericFormData = this.updateFormDataForInternalxcelUpload(formData, fileInput);
      this.uploadInternalExcel(genericFormData, fileUploader);
    }else{
      formData.append('file', fileInput);
      formData.append('workflowGroup', this.workflowName);
      this.uploadInternalExcelMidplex(formData, fileUploader);
    }
  }

}
  //Update the forma data generic to excel upload
  private updateFormDataForInternalxcelUpload(formData: FormData, fileInput: any){
    const genericFormData = new FormData();
    var jsonData = {};
    formData.forEach(function(value, key){
      jsonData[key] = value;
    });
    var inputData = JSON.stringify(jsonData);

    genericFormData.append('file', fileInput);
    genericFormData.append('uploadType', "Sample_Upload");
    genericFormData.append('requestData', inputData);

    return genericFormData;
  }

  private uploadCustomerExcel(formData: FormData, fileUploader: any) {
    this.apgTestingService.uploadSamplesExcelSheet(formData).subscribe({next:(result) => {
      if (!result) {
        return;
      }
      fileUploader.clear();
      this.blocked = false;
      this.selectedBatch = result.data;
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Sample Uploaded', detail: 'Customer Excel Upload Successful' });
    }, error: (error: any) => {
      fileUploader.clear();
      this.blocked = false;
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    }});
  }

  uploadInternalExcel(genericFormData: FormData, fileUploader: any): any {
    this.apgTestingService.uploadExcelSheet(genericFormData).subscribe({
      next : (result) => {
        if (!result) {
          return;
        }

        fileUploader.clear();
        this.selectedBatch = result.data;
        this.blocked = false;
        this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Sample Uploaded', detail: 'Internal Excel Upload Successful' });
      },
      error: (error: any) => {
        this.blocked = false;
        fileUploader.clear();
        let messageError = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(messageError);
      }
    })
  }


  uploadInternalExcelMidplex(formData: FormData, fileUploader: any): any {
    this.apgTestingService.uploadExcelSheetMidplex(formData).subscribe({
      next : (midPlexResult) => {
        if (!midPlexResult) {
          return;
        }

        fileUploader.clear();
        this.selectedBatch = midPlexResult.data;
        this.blocked = false;
        this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Sample Uploaded', detail: 'Internal Excel Upload Successful' });
      },
      error : (midPlexError : any) => {
        this.blocked = false;
        fileUploader.clear();
        let messageError = this.errorHandler.handleError(midPlexError);
        this._messagesService.addErrorMessage(messageError);
      }
   });
  }

  disableBatchReceieve(){
    var disable = false;
    if((this.selectedBatch.samples === null || this.selectedBatch.samples === undefined) ||
      ( this.selectedBatch.samples && this.selectedBatch.samples.length == 0) ||
      (this.selectedBatch.batchReceivedDateTime === undefined) ||
      (this.selectedBatch.sampleUploadedFileName === undefined)||
      !['CREATE_BATCH', 'BATCH_UPLOADED', 'BATCH_RECEIVED'].includes(this.selectedBatch.statusOfTheBatch)){
        disable = true;
      }
    return disable;
  }

  updateProcessStep(step: string, stage: ProcessStepStage, singleStage?: boolean): boolean {
    if(this.selectedBatchStepsMap.has(step)){
      var existingStep = this.selectedBatch.processSteps.find(s => s.step == step);
      if(ProcessStepStage.start==stage){
        existingStep.startTimeStamp = new Date();
        existingStep.startPUID = this.puid;
        if(singleStage){
          existingStep.endTimeStamp = new Date();
          existingStep.endPUID = this.puid;
        }
      }else if(ProcessStepStage.end==stage){
        existingStep.endTimeStamp = new Date();
        existingStep.endPUID = this.puid;
      }
    }else{
      this.selectedBatch.processSteps = (!this.selectedBatch.processSteps || this.selectedBatch.processSteps==null) ? [] : this.selectedBatch.processSteps;
      var newStep = new Step();
      newStep.step = step;
      if(ProcessStepStage.start==stage){
        newStep.startTimeStamp = new Date();
        newStep.startPUID = this.puid;
        if(singleStage){
          newStep.endTimeStamp = new Date();
          newStep.endPUID = this.puid;
        }
      }else{
        this._messagesService.addWarningMessage({
          severity: 'warn', summary: 'Action not allowed',
          detail: 'Process has to be started to perform this action'
        })
        return false;
      }
      this.selectedBatch.processSteps.push(newStep);
    }
    return true;
  }

  prepareProcessStepsMap() {
    this.selectedBatchStepsMap.clear();
    if(!this.selectedBatch.processSteps || this.selectedBatch.processSteps==null)
      return;
    this.selectedBatch.processSteps.forEach(step => {
      this.selectedBatchStepsMap.set(step.step, step);
      }
    )
  }

  receiveBatch(status: string){
    if(!this.updateProcessStep(ProcessStep.RECEIVE_BATCH, ProcessStepStage.start, true)){
      return;
    }
    this.selectedBatch.batchReceivedDateTime = new Date();
    this.selectedBatch.batchReceivedPUID = this.puid;
    this.selectedBatch.deliveryTargetDateTime = this.addBusinessDays(this.selectedBatch.batchReceivedDateTime, 7);
    this.selectedBatch.statusOfTheBatch = status;
    this.selectedBatch.previousStatusOfTheBatch = status;
    this.selectedBatch.filterDateTime = new Date();
    this.getRequiredRead();
    this.saveBatchData();
  }

  saveBatchData(){
  this.blocked=true
  this.apgTestingService.saveSampleData(this.selectedBatch, this.selectedLab.numberOfPositivePCRControls, this.selectedLab.numberOfNegativePCRControls).subscribe({
    next : (result) => {
      if (result.data) {
        this.selectedBatch = result.data;
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batch Updated!',
            detail: 'Batch ' + this.selectedBatch.batchID + ' has been updated successfully'
          });
          this.blocked = false;
          this.disableBatchReceieve();
      }
      this.blocked = false;
    },
    error: (error: any) => {
      this.errorHandlerCommon(error);
    }
    });
  }

  getExcel() {
    if(this.selectedBatch.externalIdentification === null || this.selectedBatch.externalIdentification === undefined || this.selectedBatch.externalIdentification === ''){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'ExternalIdentification is Empty',
        detail: 'Please Enter ExternalIdentification before downloading excel',
      });
    } else if(this.selectedBatch != null && this.selectedBatch != undefined && this.selectedBatch.batchID != null && this.selectedBatch.batchID != '' && this.selectedBatch.batchID != undefined) {
        this.apgTestingService.excel(this.selectedBatch).subscribe(
          result => {
            var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
            console.log("File name : " + result.filename);
            this.saveFile(blob, this.selectedBatch.batchID + ".xlsx");

          },
          error => {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          }
        )
    } else {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'No Batch ID Entered', detail: 'Please Batch ID before downloading excel' });
    }
  }

  onCustomerFileSelect(event){
    if(event.files[0].name.split('.').pop() != "xls"){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only .xls files are allowed.',
      });
    }
  }

  onInternalFileSelect(event){
    if(!(event.files[0].name.split('.').pop() === "xlsm" || event.files[0].name.split('.').pop() === "xlsx")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only .xlsm or .xlsx files are allowed.',
      });
    }
  }

  isUploadDisabled(){
    let disableUpload = false;
    if(!['CREATE_BATCH', 'BATCH_UPLOADED', 'BATCH_RECEIVED'].includes(this.selectedBatch.statusOfTheBatch)){
       disableUpload= true;
    }
    return disableUpload;
  }

  printLabelDisabledIf(){
    let disable = true;
    if(this.selectedPrinter && this.selectedTemplate && this.selectedBatch && this.selectedBatch.batchID){
      disable = false
    }
    return disable;
  }

  printLabel(){  
  }

  onSelectPrinter(){
    if(this.selectedPrinter.template){
      this.templateList.forEach(template=>{
        if(template.templateName === this.selectedPrinter.template.templateName){
          this.selectedTemplate = template;
        }
      });
    }
  }

  searchForBatchWIthFilter(){
    this.blocked=true;
    if(this.valueToSearch && this.valueToSearch.trim() ==''){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
      return;
    }

    this.apgTestingService.getBatchForLabAndBatchId(this.selectedLabId , this.selectedSearchFilter, this.valueToSearch.trim() ).subscribe({
      next : (result) => {
        if (result && result.data != null) {
          this.selectedBatch = result.data;
          this.currentSavedProduct = this.selectedBatch.product;
          this.isCreate = false;
          this.initializeMapsForShowingBatch();
          this.getSelectedSender();
          this.showMessageForSearchBatch();
          this.prepareProcessStepsMap();
          this.valueToSearch = '';
        } else {
          this._messagesService.addErrorMessage({ severity: 'error', summary: 'Batch Not Found', detail: 'Batch not found with '+this.selectedSearchFilter +' '+ this.valueToSearch.trim()});
        }
        this.blocked=false;
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }});
  }
  showMessageForSearchBatch(): any {
    if(this.selectedBatch.matchedBatchCount == 1){
      this._messagesService.addSuccessMessage({
        severity: 'success', summary: 'Batch Found!',
        detail: 'Batch for ' + this.valueToSearch + ' is Found.'});
    }else if([2,3,4,5].includes(this.selectedBatch.matchedBatchCount)){
      this._messagesService.addWarningMessage({
       severity: 'warn',
       summary: 'Multiple Batchs Found',
       detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount+' Batch Id\'s are : '
       +this.selectedBatch.matchedBatchIDs});
    }else if(this.selectedBatch.matchedBatchCount>1) {
      this._messagesService.addWarningMessage({
        severity: 'warn',
        summary: 'Multiple Batchs Found',
        detail: 'Showing Latest Batch. No. of Batchs found for given filter is: '+this.selectedBatch.matchedBatchCount});
    }
  }
  searchButtonDisabledIf(){
    return !(this.selectedSearchFilter && this.valueToSearch && this.valueToSearch.trim() != '' );
  }

populateProductsInMap() {
    this.mapOfProducts = new Map();
    this.masterDataService.getConfigList(this.selectedLabId, "product", 0, 100, true).subscribe(
      result => {
        if (result.data!= null || result.data != undefined || result.data.length != 0) {
          let products=result.data;
          console.log("Products - ", products);
          products.forEach(prod => {

            this.mapOfProducts.set(prod.name,prod.requiredRead);
            this.productList.push({ label: prod.name, value: prod.name });

            if(prod.workflowProduct!=null && prod.workflowProduct.length!=0){
              this.mapOfWorkflow.set(prod.name,prod.workflowProduct[0].workflowGroup);
            }
            this.mapOfProductTagSystem.set(prod.name, prod.tagSystem);
           });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  setRequiredRead(product:string){
    if(this.mapOfProducts.get(product)!=0){
      this.selectedBatch.requiredRead=this.mapOfProducts.get(product);
  }else{
    this.selectedBatch.requiredRead=500000;
    }
  }

  getRequiredRead(){
    const specialRegex= /[^A-Z a-z0-9]/ ;
    if(specialRegex.test(this.selectedBatch.requiredRead.toString())){
      let check = this.selectedBatch.requiredRead.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'');
      this.selectedBatch.requiredRead=Number(check);
    }
  }

  addBusinessDays(d:Date, n:number) {
    d = new Date(d.getTime());
    var day = d.getDay();
    d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
    return d;
  }
  getfunction(){
    if(this.selectedBatch.sender){
      if(this.selectedBatch.sender.length <= 21){
        return this.selectedBatch.sender
      }else if(this.selectedBatch.sender.length > 21){
        return this.selectedSender.senderShortName
      }
    }
  }

  getLatestBatchIdBySender(labId:string, selectedSender:string){
    this.blocked = true;
    this.apgTestingService.getLatestBatchIdBySender(labId, selectedSender).subscribe({
      next : (result) => {
        this.blocked = false;
        if (result.data) {
          let batchId = result.data.batchID;
          let coProjectId = result.data.coProjectId;
          let firstTwoChar = batchId.substring(0,2).trim();
          this.selectedBatch.batchID = "";
          this.selectedBatch.coProjectId = "";
          if(firstTwoChar=="CO"){
            this.selectedBatch.batchID = this.generateBatchIdForSuggestion(batchId);
          }
          if(coProjectId){
            this.selectedBatch.coProjectId = coProjectId;
          }
        }else {
          this.selectedBatch.batchID = "";
          this.selectedBatch.coProjectId = "";
        }
      },
      error: (error: any) => {
        this.errorHandlerCommon(error);
      }});
  }

  errorHandlerCommon(error){
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  generateBatchIdForSuggestion(batchId : string){
    let batchIdArray = batchId.split("_");
    let arrayLength = batchIdArray.length;
    if(batchIdArray[arrayLength-1] == "R" || batchIdArray[arrayLength-1] == "C" || batchIdArray[arrayLength-1] == "CR"){
      arrayLength = arrayLength-1;
    }
    let batchIdSuffix="";
    for(let i=0;i<arrayLength-1;i++){
      if(i==0){
        batchIdSuffix = batchIdArray[i];
      }else{
        batchIdSuffix = batchIdSuffix+"_"+batchIdArray[i];
      }
    }
    if(!isNaN(Number(batchIdArray[arrayLength-1]))){
      return batchIdSuffix+"_"+(parseInt(batchIdArray[arrayLength-1])+1);
    }
    return "";
  }

  onApplyFilter(clear:string) {
    if (this.selectedStates.length == 0 && !this.fromDate && !this.toDate) {
      this.filterBatchStatus();
    }
    else {
      this.loading = true;
      let toFilterDate: Date;
      if (!this.fromDate && !this.toDate && !clear) {
        this.toDate = new Date();
        this.fromDate = new Date();
        this.fromDate.setDate(this.toDate.getDate() - 14);
      }
      let selectedStatusList = this.getStatusList();
      if(this.toDate){
        toFilterDate = new Date(this.toDate.getTime());
        toFilterDate.setDate(toFilterDate.getDate() + 1)
      }
      this.apgTestingService.filterBatchesForSamplesMenu(selectedStatusList, this.selectedLabId, !this.fromDate ? '' : this.fromDate.toDateString(), !this.toDate ? '' : toFilterDate.toDateString(), 'OrderReception').subscribe({
        next : (results) => {
          this.loading = false;
          this.batches = results.data;
        },
        error: (error: any) => {
          this.loading = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
     })
    }
  }

  private getStatusList() {
    if (this.selectedStates && this.selectedStates.length != 0){
      return this.selectedStates.join(",");
    } else {
      return "BATCH_UPLOADED"
    }
  }
  scanPlateDisable(){

  }
  saveScanComplete(){
    this.saveBatchData();
    this.scanPlatePopup = false
    this.sampleSaveDisable = true;
  }
  scanPlate(){
    if(this.ziathHost == '' || this.ziathName == ''){
      this._messagesService.addWarningMessage({
        severity: 'warn',
        summary: 'Ziath Scanner not configured',
        detail: "Please add Ziath detailes in Machine MDM"});
        return;
    }
    this.startScanClicked = false;
    this.sampleSaveDisable = true;
    this.scanPlatePopup= true;
  }
  startScan(){
    this.containers = [];
    this.blocked = true;
    this.sampleSaveDisable = true;
    this.ziathRequest = new ZiathRequest();
    this.ziathRequest.host = this.ziathHost?.split(';')[0];
    this.ziathRequest.port = this.ziathHost?.split(';')[1];
    this.ziathRequest.scanProgramName = this.ziathName;
    this.apgTestingService.getZiatScanData(this.ziathRequest).subscribe({
      next : (results) => {
        this.blocked = false;
        let resultObj = JSON.parse(results.data);
        this.containers=resultObj.racks[0].containers;
        this.validateScanPlate()
        this.startScanClicked = true;
      },
      error: (error: any) => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })
  }
  validateScanPlate(){
    let existingSamples : CovidSamples[]=[];
    if(this.selectedBatch.samples && this.selectedBatch.samples.length>0){
      existingSamples = this.selectedBatch.samples;
    }

    let existingbarcodes =[];
    if(existingSamples && existingSamples.length>0){
      existingSamples.forEach(sample=>{
        existingbarcodes.push(sample.barcode)
      })
    }
    this.containers.forEach(cont=>{
      if('EMPTY'!=cont.barcode && !existingbarcodes.includes(cont.barcode)){
        let sample = new CovidSamples();
        sample.barcode = cont.barcode;
        sample.prositionCol = cont.col;
        sample.positionRow = cont.row;
        sample.scanTimeStamp = new Date();
        sample.contaminationType = "No Contamination";
        existingSamples.push(sample);
      }
    })
    if(existingSamples.length>88){
      this._messagesService.addWarningMessage({
        severity: 'warn',
        summary: 'More Samples',
        detail: "There are more than 88 Samples on the plate, please remove the samples out of coloumn 12 and rescan the plate."});
        return;
    }
    this.selectedBatch.samples = existingSamples;
    this.sampleSaveDisable = false;
  }
  getMachineDataforZiath(){
    this.masterDataService.getConfigList(this.selectedLab._id, "machine", 0, 100, true).subscribe(
      (results)=>{
        this.machineList = results.data;
        this.machineList.forEach(machine=>{
          if(machine.name.includes('ziat')|| machine.name.includes('Ziat')){
            this.ziathHost = machine.hostAddress;
            this.ziathName = machine.subType;
            return;
          }
        }
        )
      },(error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
  scanPlateDisabled(){
    return this.isCreate || this.selectedBatch.statusOfTheBatch != "CREATE_BATCH"
  }
}





